import React from 'react';
import { BubbleMenu } from '@tiptap/react';
import { GrTextAlignLeft } from 'react-icons/gr';
import {  RiListUnordered, RiLink, RiFontSize, RiFontColor} from 'react-icons/ri';
import { ImSubscript } from 'react-icons/im';

import Proptypes from 'prop-types';
import { Col } from 'reactstrap';

import { formatters } from '../utils';
import DropDown from './DropDown';

export default function SmallToolbar({ editor }) {
  if(!editor) return null;

  return (
    <Col size="12" className='flex border-1 twy-border-base p-1 align-center'>
      {formatters.clearFormatter(editor)}
      <DropDown id='title-formatters' icon={RiFontSize} tooltipText='title formatters' small={true}>
        {formatters.titleFormatters(editor)}
      </DropDown>
      <DropDown id='align-formatters' icon={GrTextAlignLeft} tooltipText='align formatters' small={true}>
        {formatters.alignFormatters(editor)}
      </DropDown>
      <DropDown id='color-formatters' icon={RiFontColor} tooltipText='color formatters' small={true}>
      {formatters.colorFormatters(editor)}
      </DropDown>
      <DropDown id='scrip-formatters' icon={ImSubscript} tooltipText='script formatters' small={true}>
        {formatters.scriptFormatters(editor)}
      </DropDown>
      <DropDown id='list-formatters' icon={RiListUnordered} tooltipText='list formatters' small={true}>
        {formatters.listFormatters(editor)}
      </DropDown>
      <DropDown id='link-formatters' icon={RiLink} tooltipText='link formatters' small={true}>
        {formatters.linkFormatters(editor)}
      </DropDown>
      {formatters.specialFormatters(editor)}
      <BubbleMenu editor={editor} tippyOptions={{ duration: 100, placement: 'bottom' }}>
        <div className='flex'>
          {formatters.markFormatters(editor)}
        </div>
      </BubbleMenu>
    </Col>
  )
}

SmallToolbar.propTypes = {
  editor: Proptypes.object,
}
